import { render, staticRenderFns } from "./HumanResources.vue?vue&type=template&id=2742a62f&scoped=true"
import script from "./HumanResources.vue?vue&type=script&lang=js"
export * from "./HumanResources.vue?vue&type=script&lang=js"
import style0 from "./HumanResources.vue?vue&type=style&index=0&id=2742a62f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2742a62f",
  null
  
)

export default component.exports